module.exports = __webpack_public_path__ + "img/2.243a1aa2.png";